const i = ({
  onChange: a
}) => {
  let s = {
    isUploading: !1,
    progress: 0,
    total: 0,
    isUploaded: !1
  };
  const o = () => {
    a(s);
  }, l = () => {
    s = {
      ...s,
      progress: 0,
      total: 0,
      isUploading: !0,
      isUploaded: !1
    }, o();
  }, d = () => {
    s = {
      ...s,
      isUploading: !1,
      isUploaded: !0
    }, o();
  }, t = (r, e) => {
    e && (s = {
      ...s,
      progress: Math.round(r * 100 / e),
      total: e
    }, o());
  };
  return {
    getState: () => s,
    startProgress: l,
    finishProgress: d,
    updateProgress: t,
    resetProgress: () => {
      s = {
        progress: 0,
        total: 0,
        isUploading: !1,
        isUploaded: !1
      }, o();
    },
    progressHandler: (r) => {
      const e = r.loaded, n = r.total;
      t(e, n);
    }
  };
};
export {
  i as createProgress
};
